import { LoadingScreen } from '@shared/ui';
import { AppLogo } from './app-logo';

/**
 * 帶上本 app logo 的整頁載入畫面。確認登入狀態與載入當日紀錄都用它，
 * 兩段接連的等待讀起來就只是一次。
 */
export function AppLoadingScreen() {
  return <LoadingScreen logo={<AppLogo size={64} />} className="min-h-dvh" />;
}
